import React, { useId } from 'react';
type SwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
};
export function Switch({
  checked,
  onChange,
  label,
  description
}: SwitchProps) {
  const id = useId();
  return <div className="flex items-center gap-3" data-id="element-144" data-mp="1mdogqkkmr51y">
      <button id={id} type="button" role="switch" aria-checked={checked} onClick={() => onChange(!checked)} className={`relative h-7 w-12 shrink-0 rounded-full duration-150 ease-out focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-flame/30 motion-safe:transition-colors ${checked ? 'bg-flame' : 'bg-navy-200'}`} data-id="element-145" data-mp="1hdaifu8tz9h4">
        <span className={`absolute left-1 top-1 h-5 w-5 rounded-full bg-white shadow-bubble duration-200 ease-out motion-safe:transition-transform ${checked ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-146" data-mp="20c4uuwktnxu4" />
      </button>
      <label htmlFor={id} className="cursor-pointer select-none" data-id="element-147" data-mp="2sy7i6e8e8rf7">
        <span className="block whitespace-nowrap text-sm font-extrabold text-navy" data-id="element-148" data-mp="ys3jyovws5kq">{label}</span>
        {description && <span className="block text-xs font-semibold text-navy-500" data-id="element-149" data-mp="13pv7l6pit5j4">{description}</span>}
      </label>
    </div>;
}